/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/CreditCard.yaml
import { ScanbotCreditCardImpl } from './impl';
/**
 * Entry point for all Credit Card scanning features.
 */
export const ScanbotCreditCard = {
    /**
     * Opens the Ready-To-Use UI Credit Card scanner with the desired configuration.
     * @param {CreditCardScannerScreenConfiguration} configuration - The Credit Card scanner configuration to be used for scanning.
     * @returns {Promise<ResultWrapper<CreditCardScannerUiResult>>} - The result of the Credit Card scanning operation.
     */
    async startScanner(configuration) {
        return ScanbotCreditCardImpl.startScanner(configuration);
    },
    /**
     * Scans Credit Card from a given image with the desired configuration.
     * @param {ImageInput} params.image - The image to be used for scanning.
     * @param {CreditCardScannerConfiguration} params.configuration - The Credit Card scanner configuration to be used for scanning.
     * @returns {Promise<CreditCardScanningResult>} - The result of the Credit Card scanning operation.
     */
    async scanFromImage(params) {
        return ScanbotCreditCardImpl.scanFromImage(params);
    },
};
//# sourceMappingURL=CreditCard.js.map